/*
English message to show user when this question and their age group matches.

{0} - name of population group
{1} - total population of group
{2} - total immunized in group
{3} - start position of your queue
{4} - end position of your queue
{5} - Doses Allocated
{6} - Total Number of people ahead based on uptake (70,80,90,100)
{7} - Uptake Percentage.

*/
export default {
	'en-CA': {
		'headerTitle': 'Education Property Tax<br/>Rebate Calculator',
		'headerTotalText': '',
		'headerTotalAsOfText': '',
		'headerIntro': 'Use this calculator to estimate how much you will receive for your education property tax rebate.',
		'headerBody': '',
		'headerSubtitle': '',
		'boxHeaderTitle': 'To get started, grab your 2023 property tax bill',
		'boxHeaderInfo': '',
		'boxSubHeaderTitle': 'Enter Property Information',
		'boxSubHeaderSubTitle': 'Add as many properties and assessments as needed.',
		'lastUpdated': 'Last Updated: ',
		'class': 'Class',
		'propertyHeader': 'Property ',
		'assessmentHeader': 'Assessment ',
		'selectClass': 'Select Class',
		'portionedAssessment': 'Portioned Assessment',
		'schoolDivisionMillRate': 'School Division Mill Rate',
		'educationSupportLevy': 'Education Support Levy Mill Rate',
		'schoolTax': 'Education Property Tax',
		'educationPropertyTaxRebate': 'Education Property Tax Rebate',
		'class.residential1': 'Residential 1',
		'class.residential2': 'Residential 2',
		'class.residential3': 'Residential 3',
		'class.farmProperty': 'Farm Property',
		'class.otherProperty': 'Other Property',
		'Total Rebate': 'Total Rebate',
		'disclaimer': '<span>Disclaimer:</span> Total rebate amount is only an estimate.',
		'calculate': 'Education Property Tax Rebate Summary',
		'rollNumber': 'Property Roll No.',
		'addPropertyButton': 'Add Another Property',
		'addAssessmentButton': 'Add Another Assessment to this Property',
		'removePropertyButton': 'Delete',
		'removeAssessmentButton': 'Delete',
		'nullRollNumber': 'Not Entered',
		'summaryTitle': 'Summary',
		'summaryTotalsHeading': 'Education Property Tax Per Property/Assessment',
		'summaryTaxHeading': 'Total Education Property Tax Owing',
		'summaryRebateHeading': 'Total Rebate Amount',
		'summaryRebateBody': '',
		'rebate': 'Rebate',
		'propertyRebate': 'Property Rebate',
		'help': 'Check your mail box!',
		'help.schoolDivisionMillRate.residential1': 'Residential 1',
		'help.schoolDivisionMillRate.residential2': 'Residential 2',
		'help.schoolDivisionMillRate.residential3': 'Residential 3',
		'help.schoolDivisionMillRate.farmProperty': 'Farm Property',
		'help.schoolDivisionMillRate.otherProperty': 'Other Property',
		'help.educationSupportLevy.otherProperty': 'Other Property',
		'help.ok': 'Close',
	},
	'fr-CA': {
		'headerTitle': 'Calculateur du remboursement<br/>de l\'imp&#244;t foncier pour l\'&#233;ducation',
		'headerTotalText': '',
		'headerTotalAsOfText': '',
		'headerIntro': 'Utilisez ce calculateur pour conna&#238;tre le montant du remboursement de l\'imp&#244;t foncier pour l\'&#233;ducation que vous recevrez.',
		'headerBody': '',
		'headerSubtitle': '',
		'boxHeaderTitle': 'POUR COMMENCER, PRENEZ VOTRE FACTURE D\'IMP&#212;T FONCIER DE 2023',
		'boxHeaderInfo': '',
		'boxSubHeaderTitle': 'SAISISSEZ L\'INFORMATION CONCERNANT LE BIEN',
		'boxSubHeaderSubTitle': 'Ajoutez autant de biens et d\'&#233;valuations que vous voulez.',
		'lastUpdated': '',
		'class': 'Cat&#233;gorie',
		'propertyHeader': 'Bien ',
		'assessmentHeader': '&#201;valuation ',
		'selectClass': 'Choisir la cat&#233;gorie',
		'portionedAssessment': 'Valeur fractionn&#233;e',
		'schoolDivisionMillRate': 'Taux par mille de la division scolaire',
		'educationSupportLevy': 'Taux par mille de la taxe d\'aide &#224; l\'&#233;ducation',
		'schoolTax': 'Imp&#244;t foncier pour l\'&#233;ducation',
		'educationPropertyTaxRebate': 'Remboursement de l\'imp&#244;t foncier pour l\'&#233;ducation',
		'class.residential1': 'Biens r&#233;sidentiels 1',
		'class.residential2': 'Biens r&#233;sidentiels 2',
		'class.residential3': 'Biens r&#233;sidentiels 3',
		'class.farmProperty': 'Biens agricoles',
		'class.otherProperty': 'Autres biens',
		'Total Rebate': 'Remboursement total',
		'disclaimer': '<strong>Avertissement :</strong> Le montant total du remboursement est donn&#233; &#224; titre indicatif.',
		'calculate': 'SOMMAIRE DU REMBOURSEMENT DE L\'IMP&#212;T FONCIER POUR L\'&#201;DUCATION',
		'rollNumber': 'N<sup>o</sup> de r&#244;le',
		'addPropertyButton': 'AJOUTER UN AUTRE BIEN',
		'addAssessmentButton': 'AJOUTER UNE AUTRE &#201;VALUATION DE CE BIEN',
		'removePropertyButton': 'SUPPRIMER',
		'removeAssessmentButton': 'SUPPRIMER',
		'nullRollNumber': 'Donn&#233;e manquante',
		'summaryTitle': 'Sommaire',
		'summaryTotalsHeading': 'IMP&#212;T FONCIER POUR L\'&#201;DUCATION PAR BIEN/&#201;VALUATION',
		'summaryTaxHeading': 'IMP&#212;T FONCIER POUR L\'&#201;DUCATION EXIGIBLE',
		'summaryRebateHeading': 'MONTANT TOTAL DU REMBOURSEMENT',
		'summaryRebateBody': 'Remboursement',
		'rebate': '',
		'propertyRebate': 'Remboursement pour le bien',
		'help': 'V&#233;rifiez votre bo&#238;te de r&#233;ception!',
		'help.schoolDivisionMillRate.residential1': 'Biens r&#233;sidentiels 1',
		'help.schoolDivisionMillRate.residential2': 'Biens r&#233;sidentiels 2',
		'help.schoolDivisionMillRate.residential3': 'Biens r&#233;sidentiels 3',
		'help.schoolDivisionMillRate.farmProperty': 'Biens agricoles',
		'help.schoolDivisionMillRate.otherProperty': 'Autres biens',
		'help.educationSupportLevy.otherProperty': 'Autres biens',
		'help.ok': 'Fermer',
	},
};